/**
 * 키오스크 문구 — 한국어(기준 로케일). HERIT 다국어표(`HERIT_UI_다국어.docx`) 키는 표 문안 그대로,
 * 나머지는 담다 프로토타입 카피 기준. 줄바꿈은 "\n"(web `Lines` 가 <br/> 로), 숫자는 "{n}"/"{sec}" 템플릿.
 */
export const COPY_KO = {
    "common.back": "뒤로",
    "common.brandCaption": "한국의 아름다움, 나의 한 장",
    "common.brandTag": "한국 문화 포토부스",
    "common.home": "처음으로",
    "common.keepGoing": "계속하기",
    "common.homeConfirmTitle": "처음으로 돌아갈까요?",
    "common.homeConfirmBody": "지금까지 진행한 내용은 사라져요.",
    "idle.title": "아직 계신가요?",
    "idle.body": "{sec}초 동안 아무 응답이 없으면 처음으로 돌아갑니다",
    "journey.theme": "테마 선택",
    "journey.style": "스타일 선택",
    "journey.capture": "사진 촬영",
    "journey.result": "결과 확인",
    "journey.receive": "사진 받기",
    // HERIT 어트랙트 카피
    "attract.tagline": "한국 문화 AI 포토부스",
    "attract.headline": "한국의 아름다움에\n나를 담는 순간",
    "attract.cta": "시작하기",
    "themeSelect.title": "테마를 선택해 주세요",
    "themeSelect.count": "{n}가지 테마",
    "themeSelect.cta": "선택하기",
    "themeSelect.storiesLabel": "담긴 이야기",
    "styleSelect.back": "테마 다시 고르기",
    "styleSelect.title": "스타일을 골라 주세요",
    "styleSelect.cta": "이 스타일로 갈래요",
    "styleSelect.next": "다음 스타일 보기",
    // consent
    "consent.title": "사진을 찍기 전에\n동의가 필요해요",
    "consent.required": "필수",
    "consent.view": "보기",
    "consent.close": "닫기",
    "consent.allAgree": "전체 동의",
    "consent.processor": "개인정보처리자 {name}",
    "consent.contact": "문의 {contact}",
    "consent.refusal": "동의하지 않으면 촬영 서비스를 이용할 수 없습니다",
    "consent.cta": "동의",
    "consent.decline": "미동의",
    "consent.back": "스타일 선택으로",
    "preview.back": "스타일 다시 고르기",
    "preview.title": "카메라를 봐 주세요",
    "preview.tip1": "얼굴이 잘 보이도록 정면을 바라봐 주세요.",
    "preview.tip2": "촬영 버튼을 누르면 {sec}초 뒤에 찍혀요.",
    "preview.tip3": "결과가 마음에 들지 않으면 다시 찍을 수 있어요.",
    "preview.placeholderTitle": "카메라 앞에 서주세요",
    "preview.placeholderBody": "카메라를 연결하고 있어요.\n처음이라면 카메라 권한을 허용해 주세요.",
    "preview.connecting": "카메라 연결 중…",
    "preview.shoot": "촬영하기",
    "preview.openCamera": "카메라 켜기",
    "preview.closeCamera": "안내로 돌아가기",
    "preview.cancel": "촬영 취소",
    "preview.retry": "카메라 다시 연결하기",
    "preview.note": "촬영한 사진은 AI 변환에만 사용해요.",
    "preview.holdStill": "움직이지 마세요",
    "preview.confirmTitle": "이 사진으로 진행할까요?",
    "preview.confirmHint": "눈을 감았거나 흔들렸다면 다시 찍어 주세요.",
    "preview.confirmRetake": "다시 찍기",
    "preview.confirmProceed": "이대로 진행",
    "preview.errorTitle": "카메라를 사용할 수 없어요",
    "preview.errorTitleNoDevice": "카메라가 없어요",
    "preview.errorPermissionDenied": "카메라 권한이 꺼져 있어요. 브라우저 설정에서 카메라를 허용한 뒤 다시 연결해 주세요.",
    "preview.errorNoDevice": "이 기기에서 연결된 카메라를 찾지 못했어요. 카메라를 연결한 뒤 다시 시도해 주세요.",
    "preview.errorInsecureContext": "HTTPS 주소에서만 카메라를 사용할 수 있어요.",
    "preview.errorTimeout": "카메라가 응답하지 않아요. 다른 앱이 카메라를 쓰고 있지 않은지 확인한 뒤 다시 연결해 주세요.",
    "preview.errorUnknown": "카메라를 연결하지 못했어요. 다시 연결해 주세요.",
    "generate.title": "사진을 만들고 있어요",
    "generate.hint": "약 30초 정도 걸려요",
    // 스타일 칩 킥커·하단 진행 라벨 — 레퍼런스가 영문 고정이라 전 언어 동일
    "generate.selectedLabel": "SELECTED STYLE",
    "generate.developing": "DEVELOPING",
    "generate.step0": "얼굴을 살펴보고 있어요",
    "generate.step1": "의상을 입혀드리는 중",
    "generate.step2": "배경을 그리는 중",
    "generate.step3": "마무리 디테일 추가 중",
    "generate.remaining": "약 {sec}초 남음",
    "generate.almostDone": "거의 다 됐어요",
    "generate.queueWait": "대기열이 길어요. 잠시만 기다려주세요",
    "generate.tookTooLong": "오래 걸리고 있어요",
    "generate.failed": "변환에 실패했어요",
    "generate.cancel": "취소",
    "generate.retry": "다시 시도",
    "generate.proceed": "그대로 진행",
    "generate.back": "촬영으로 돌아가기",
    "review.title": "완성되었어요",
    "review.retake": "다시 찍기",
    "review.next": "사진 받기",
    "review.makeVideo": "✨ 영상으로도 만들기",
    "review.makeVideoPriced": "✨ 영상으로도 만들기 · +{price}",
    "review.slotError": "변환 실패",
    "videoIntro.back": "결과로 돌아가기",
    "videoIntro.title": "움직이는 화보",
    "videoIntro.body": "5초, 세로 영상.\n휴대폰으로 받아 바로 올릴 수 있습니다.",
    "videoIntro.cta": "만들기",
    "videoIntro.skip": "사진만 할게요",
    "videoMotions.back": "결과로 돌아가기",
    "videoMotions.title": "동작을 골라 주세요",
    "videoMotions.subtitle": "최대 두 개 · 고른 순서대로 이어집니다",
    "videoMotions.hint": "동작을 하나 이상 골라 주세요",
    "videoMotions.next": "다음",
    "videoCaption.back": "뒤로",
    "videoCaption.title": "한 줄을 남기시겠어요?",
    "videoCaption.subtitle": "영상 안에 자막으로 들어갑니다",
    "videoCaption.placeholder": "최대 12자",
    "videoCaption.preset1": "제주에서, 오늘",
    "videoCaption.preset2": "바람이 데려온 날",
    "videoCaption.preset3": "우리 오래 남기를",
    "videoCaption.preset4": "좋은 일만",
    "videoCaption.next": "다음",
    "videoCaption.skip": "넣지 않기",
    "videoGenerate.back": "결과로 돌아가기",
    "videoGenerate.title": "영상 제작을 시작하고 있어요",
    "videoGenerate.caption": "잠시만 기다려 주세요",
    "videoGenerate.error": "영상 생성에 실패했어요",
    "videoGenerate.retry": "다시 시도",
    "videoGenerate.skipToPhoto": "사진만 받기",
    "videoGenerate.refunded": "영상 금액은 결제하신 수단으로 자동 환불돼요.",
    "payment.title": "결제하기",
    "payment.cancel": "취소",
    "payment.kicker": "SCAN TO PAY",
    "payment.itemPhoto": "사진 인화 1장",
    "payment.itemVideo": "움직이는 화보 5초",
    "payment.total": "합계",
    "payment.qrHeading": "휴대폰으로 결제해 주세요",
    "payment.qrHint": "휴대폰 카메라로 QR 을 비춰주세요",
    "payment.methods": "카카오페이 · 네이버페이 · 토스페이 · 카드",
    "payment.noticeVideo": "결제가 확인되면 영상 제작이 시작됩니다.\n결제 전에는 만들지 않습니다.",
    "payment.noticePhoto": "결제가 확인되면 사진을 받을 수 있어요.",
    "payment.remaining": "{time} 남음",
    "payment.wifiHint": "휴대폰 데이터가 안 되면 매장 Wi-Fi 를 이용해 주세요.",
    "payment.connectionLost": "연결을 확인하는 중이에요. 결제가 완료되면 자동으로 진행돼요.",
    "payment.failedHint": "결제가 완료되지 않았어요. 휴대폰에서 다시 시도해 주세요.",
    "payment.unavailable": "지금은 결제를 사용할 수 없어요.\n직원을 불러 주세요.",
    "payment.createError": "결제를 준비하지 못했어요. 다시 시도해 주세요.",
    "payment.expired": "결제 시간이 지났어요. 다시 진행해 주세요.",
    "payment.closed": "결제가 취소되었어요. 다시 진행해 주세요.",
    "printShare.title": "사진 받아 가세요",
    // HERIT 받기 화면 — 킥커는 영문 고정
    "printShare.kicker": "SCAN TO SAVE",
    "printShare.qrHeading": "휴대폰에 저장하기",
    "printShare.desc1": "QR을 찍으면 폰에 저장돼요",
    "printShare.desc2": "링크는 {days}일만 열려요",
    "printShare.privacy": "촬영 원본은 변환 직후 삭제 · 생성본은 {days}일 뒤 삭제",
    "printShare.printCta": "인쇄하기",
    "printShare.retake": "다시 찍기",
    "printShare.home": "처음으로",
    "printShare.doneCta": "완료",
    "printShare.shareHint": "인쇄하기를 누른 뒤 공유 목록에서 '프린트' 를 선택해 주세요",
    "printShare.bodyWithVideo": "QR을 찍으면 사진과 영상을 함께 받을 수 있어요.",
    "printShare.bodyVideoPending": "사진은 지금 바로, 영상은 약 2분 뒤\n같은 링크에 뜹니다",
    "printShare.bodyVideoFailed": "영상을 만들지 못했어요.\n사진은 그대로 받을 수 있어요.",
    "printShare.videoPendingLabel": "만드는 중",
    "printShare.photoLabel": "사진",
    "printShare.videoLabel": "영상",
    "printShare.uploading": "업로드",
    "printShare.uploadError": "업로드에 실패했어요. 다시 시도해 주세요.",
    "printShare.retry": "다시 시도",
    "printShare.qrAlt": "사진 수령 페이지 QR 코드",
    "printShare.agentOffline": "프린터 연결을 확인하는 중이에요. 인쇄가 조금 늦어질 수 있어요.",
    "thanks.title": "고맙습니다",
    "thanks.body": "예쁘게 남겨드렸어요 · {sec}초 후 첫 화면으로 돌아갑니다",
    "thanks.tapHint": "화면을 터치하면 즉시 돌아갑니다",
    "lock.title": "현재 사용할 수 없습니다",
    "lock.body": "Currently Unavailable",
    // 인쇄 중 화면(BOOTH-39) — status 는 스텁 고정 문구, 실제 진행은 job 연동 후
    "print.title": "인쇄 중입니다.",
    "print.sub": "사진 챙기는 거 잊지 마세요.",
    "print.status": "PRINTING · 1 / 1 · 약 18초",
    "print.preparing": "인쇄 준비 중입니다.",
    "print.delayed": "인쇄가 지연되고 있어요.\n직원을 불러 주세요.",
    "print.delayedHint": "사진은 QR 로 받을 수 있어요.",
    "print.failed": "인쇄에 실패했어요.\n직원을 불러 주세요.",
    "print.paperOut": "용지가 없어요.\n직원을 불러 주세요.",
};
//# sourceMappingURL=ko.js.map